export default "__VITE_ASSET__d8pX1x3B__"